module.exports = __webpack_public_path__ + "static/media/search.b21cf045.svg";